import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { DS } from '../PatientForms/designTokens';

interface FormSubmittedViewProps {
  title?: string;
  message?: string;
}

const FormSubmittedView: React.FC<FormSubmittedViewProps> = ({
  title = 'Formuläret har skickats in!',
  message = 'Tack för dina svar! Du är välkommen till ditt läkarbesök.',
}) => (
  <Box
    sx={{
      minHeight: '100vh',
      backgroundColor: '#F0EDE6',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        p: 2,
        width: '100%',
        maxWidth: '384px',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          px: 2.5,
          py: 3.5,
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: DS.deepTeal,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          <CheckIcon sx={{ color: '#fff', fontSize: 24 }} />
        </Box>
        <Typography
          sx={{
            fontSize: '17px',
            fontWeight: 600,
            color: DS.deepTeal,
            mb: 1,
            fontFamily: DS.fontDisplay,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            color: '#6B7280',
            lineHeight: 1.5,
            fontFamily: DS.fontBody,
          }}
        >
          {message}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontSize: '13px',
          color: '#9CA3AF',
          textAlign: 'center',
          fontFamily: DS.fontBody,
        }}
      >
        Stäng för att gå tillbaka till appen
      </Typography>
    </Box>
  </Box>
);

export default FormSubmittedView;
